import { PureLightTheme } from "../../../styles/theme"
import { COLORS } from "../../../styles/variables"

export const CardFiltration = {
  maxHeight: '808px',
  height: '100%',
  overflowY: 'auto',
  width: '360px',
  padding: 5,
  '@media (max-width:1200px)': {
    width: '260px',
    paddingX: 3,
  },
  [PureLightTheme.breakpoints.down('md')]: {
    height: 'auto',
    paddingY: 3,
  }
}

export const FiltrationText = {
  mb: "8px",
}

export const FiltrationAutocomplete = {
  marginBottom: "16px" 
}

export const StackAge = {
  alignItems: 'center', 
  marginBottom: '16px',
}

export const BoxAge = {
  width: '100%',
}

export const DividerStyled = {
  margin: '0px 8px 0px 8px', 
  width: '14px', 
  background: COLORS.BLACK, 
  border: '1px solid',
}

export const AgeStyled = {
  "@media (max-width:1200px)": {
    maxWidth: '89px',
    width: '100%',
    "& .MuiInputBase-input": {
      textAlign: 'center',
      padding: '0px!important',
    },
  },
}
